const Close = () => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75 5.25L12.5 12M12.5 12L5.75 18.75M12.5 12L19.25 18.75M12.5 12L19.25 5.25" stroke="#97A6A3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default Close